import { SelectOptionsFormated, SelectOptionsResponse } from 'src/models/interface/selectOptions'

export function selectOptionsToDomain(dto: SelectOptionsResponse, field: string): SelectOptionsFormated {
  const result = {
    id: field,
    options: [] as Array<{ text: string; value: string }>
  }

  const formatedOptions = dto.map(option => ({
    text: option.descricao,
    value: option.valor
  }))

  result.options = formatedOptions

  return result
}
